// ── report-enqueue-result: HONEST pending/queued render (FR-REPORT) ─────────
// Renders the report generate/regenerate enqueue envelope as exactly what it is:
// while the report-agent lane is closed the backend returns status:'pending' +
// report:null + generated:false + reportAgentLaneOpen:false — we render a
// "queued / pending" notice and NEVER a fabricated 'generated' or a fake report
// body. When the lane is open the status is 'queued'. Same render for both
// generate and regenerate.

import { Alert } from "@vjal/ui";

import type { CoachingReportEnqueueResponseDto } from "../../services/coaching-readiness-dtos";

export function ReportEnqueueResult({ result }: { result: CoachingReportEnqueueResponseDto | null }) {
  if (!result) return null;
  const pending = result.status === "pending" || !result.reportAgentLaneOpen;
  const enqueuedTypes = result.reports.filter((entry) => entry.enqueued).length;
  return (
    <Alert variant={pending ? "warning" : "info"}>
      {pending ? (
        <>
          Generation is queued (status: {result.status}). The report-generation lane is currently closed, so no report has
          been produced yet — nothing is fabricated. {enqueuedTypes > 0 ? `${enqueuedTypes} report type(s) enqueued.` : ""}{" "}
          Reports appear once the lane is enabled.
        </>
      ) : (
        <>
          Generation queued (status: {result.status}). {enqueuedTypes} report type(s) enqueued. The report will appear in
          the reports list once it finishes generating — it is not ready to read yet.
        </>
      )}
    </Alert>
  );
}
